import React from "react";
import tw from "tailwind-styled-components";
import PropTypes from "prop-types";

const InputWrapper = tw.input`
text-black shadow block sm:text-sm rounded-md

${(p) => {
  if (p.intent === "danger") {
    return `
      border-red-300 text-red-900 placeholder-red-300 focus:outline-none
      sm:text-sm focus:ring-red-500 focus:border-red-50
    `;
  }
  return "focus:ring-sky-500 focus:border-sky-500 border-white ";
}}
`;

export default function Input(props) {
  return <InputWrapper ref={props.innerRef} {...props} />;
}

Input.propTypes = {
  innerRef: PropTypes.any,
};
